<template>
  <div class="BlacklistSettingAction table">
    <div ref="caozuo" style="height:40px;margin-bottom:4px">
      <el-button size="small" @click="shuaxin">
        <i class="el-icon-refresh-right"></i>
        刷新</el-button
      >
    </div>
    <el-table
      :height="zhanshi"
      :data="tableData"
      style="width: 100%"
      :header-cell-style="headerCellStyle"
      :cell-style="cellStyle"
      ref="multipleTable"
    >
      <el-table-column type="selection" min-width="35"></el-table-column>
      <el-table-column label="商品名称" prop="shop_name">
        <template slot-scope="scope">
          <span>{{ scope.row.callTypeInfo.card }}</span>
        </template>
      </el-table-column>
      <el-table-column label="商品内容" prop="shop_content">
        <template slot-scope="scope">
          <span>{{
            scope.row.callTypeInfo.shop_content
              ? "一个月有效期"
              : "一个月有效期"
          }}</span>
        </template>
      </el-table-column>
      <el-table-column label="总数" prop="sum"></el-table-column>
      <el-table-column label="已派发数量" prop="use"></el-table-column>
      <el-table-column label="剩余可用数量" prop="remain">
        <template slot-scope="scope">
          <span>{{ scope.row.sum - scope.row.use }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="total" label="操作" width="240">
        <template slot-scope="scope">
          <el-link type="primary" @click="Distribute(scope.row)">派发 </el-link>
          <span class="activespan">|</span>
          <el-link type="primary" @click="Details(scope.row)">详情 </el-link>
        </template>
      </el-table-column>
    </el-table>

    <el-dialog
      title="追加APP授权数量"
      :visible.sync="dialogaddVisible"
      width="600px"
    >
      <el-form :rules="rules2" ref="forms" :model="forms">
        <el-form-item label="追加商品:" label-width="180px">
          <span class="el-span">{{ row.callTypeInfo.card }}</span>
        </el-form-item>
        <el-form-item label="总数:" label-width="180px">
          <span class="el-span">{{ row.sum }}个</span>
        </el-form-item>
        <el-form-item label="剩余可用数量:" label-width="180px">
          <span class="el-span">{{ row.sum - row.use }}个</span>
        </el-form-item>
        <el-form-item label="APP授权数" label-width="180px" prop="number">
          <el-input
            v-model="forms.number"
            placeholder="请输入"
            style="width: 270px"
            @input="numberLength"
            onkeyup="value=value.replace(/[^\d]/g,'').replace(/^0{1,}/g,'')"
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogaddVisible = false">取 消</el-button>
        <el-button type="primary" @click="addAuthorization('forms')"
          >确 定</el-button
        >
      </div>
    </el-dialog>
    <el-dialog
      title="派发"
      :visible.sync="dialogDistributeVisible"
      width="700px"
    >
      <el-form :rules="rules" ref="form" :model="form">
        <el-form-item label="派发商品:">
          <span class="el-span">{{ row.callTypeInfo.card }}</span>
        </el-form-item>
        <el-form-item label="派发对象:">
          <el-radio-group v-model="select">
            <el-radio class="el-span" :label="2">代理商</el-radio>
            <el-radio class="el-span" :label="3">个人</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label style="margin-bottom: 0;float:right">
          <el-select
            v-model="field"
            placeholder="请选择"
            size="small"
            class="especially"
            style="width: 110px"
            @change="changefield"
          >
            <el-option label="用户名" value="1"></el-option>
            <el-option label="企业" value="2" v-if="select == 3"></el-option>
            <el-option label="手机号" value="3"></el-option>
          </el-select>
          <!-- 关键字 -->
          <el-select
            v-if="field == 2"
            v-model="keywords"
            filterable
            placeholder="请输入企业名称"
            style="width: 160px"
            size="small"
            class="especially2"
            @change="esarchang"
            clearable
          >
            <el-option
              v-for="item in companyData"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            ></el-option>
          </el-select>
          <el-input
            @input="esarchang"
            placeholder="请输入"
            size="small"
            v-model="keywords"
            style="width: 160px"
            class="especially2"
            v-else
          >
            <i slot="suffix" class="el-input__icon el-icon-search"></i>
          </el-input>
        </el-form-item>
        <el-table
          height="400px"
          :data="agentList"
          style="width: 100%"
          :row-style="{ height: '40px' }"
          :cell-style="{ padding: '0' }"
          :header-row-style="{ height: '40px' }"
          :header-cell-style="{ padding: '0' }"
          highlight-current-row
          @selection-change="handleSelectionChange"
          @row-click="handdle"
        >
          <el-table-column type="selection" width="50"></el-table-column>
          <el-table-column prop="name" label="姓名"> </el-table-column>
          <el-table-column prop="mobile" label="手机号"></el-table-column>
          <el-table-column
            v-if="select == 3"
            prop="label"
            label="企业"
            width="120"
          >
            <template slot-scope="scope">
              <span v-if="scope.row.CompanyInfo.name" style="color: #359746">
                {{ scope.row.CompanyInfo.name }}
              </span>
              <span v-else>--</span>
            </template>
          </el-table-column>
          <el-table-column
            v-if="select == 3"
            prop="app_expiration_time"
            label="APP授权到期时间"
            width="180"
          >
            <template slot-scope="scope">
              <span v-if="scope.row.app_expiration_time">{{
                scope.row.app_expiration_time
              }}</span>
              <span v-else>--</span>
            </template>
          </el-table-column>
        </el-table>

        <el-form-item
          :label="`给每个用户授权(可派发${row.sum - row.use}个):`"
          prop="num"
        >
          <el-input
            v-model="form.num"
            style="width: 270px"
            @input="changeNumber"
            onkeyup="value=value.replace(/[^\d]/g,'').replace(/^0{1,}/g,'')"
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogDistributeVisible = false">取 消</el-button>
        <el-button type="primary" @click="onDistribute('form')"
          >确 定</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { getData, postData } from "@/api/index";
import { height1 } from "@/utils/height";
export default {
  data() {
    return {
      zhanshi: "800px",
      formes: {
        page: 1,
        pagesize: 20,
      },
      select: 2,
      field: "1",
      form: {
        num: "",
      },
      forms: {
        number: "",
      },
      tableData: [],
      agentList: [],
      total: 0, //默认数据总数
      pagesize: 15, //每页的数据条数
      currentPage: 1, //默认开始页面
      //弹出层
      dialogaddVisible: false,
      dialogDistributeVisible: false,
      rules: {
        num: [
          { required: true, message: "请输入APP授权数量", trigger: "blur" },
        ],
      },
      rules2: {
        number: [
          { required: true, message: "请输入APP授权数量", trigger: "blur" },
        ],
      },
      row: {
        callTypeInfo: { card: "" },
      },
      radio: {},
      keywords: "",
      ids: [],
      url: "",
      call_type_id: "",
      companyData: [],
    };
  },
  created() {
    this.getMenuList();
    this.getCompany();
  },
  mounted() {
    setTimeout(() => {
      var H = document.body.clientHeight;
      this.zhanshi = H - height1;
    }, 100);
    const that = this;
    window.onresize = () => {
      var H = document.body.clientHeight;
      that.zhanshi = H - height1;
    };
  },
  methods: {
    changefield() {
      this.keywords = "";
      this.esarchang();
    },
    getCompany() {
      getData("company.CompanyController/tableListAction").then((res) => {
        if (res.code == 200) {
          this.companyData = res.data;
        } else {
          this.companyData = [];
        }
      });
    },
    handleSelectionChange(val) {
      this.ids = [];
      val.forEach((i) => {
        this.ids.push(i.id);
      });
    },

    esarchang() {
      let params = {
        role: this.select,
        page: 1,
        pagesize: 20000,
        is_direct_son: 1,
        call_type_id: this.call_type_id,
      };
      if (this.select == 2) delete params.call_type_id;
      if (this.keywords !== "") {
        if (this.field == "1") {
          params.name = this.keywords;
        } else if (this.field == "2") {
          params.company_id = this.keywords;
        } else if (this.field == "3") {
          params.mobile = this.keywords;
        }
      }
      getData("UserController/pageAction", params).then((res) => {
        if (res.code == 200) {
          this.agentList = res.data.data;
        }
      });
    },
    handdle(row) {
      this.radio = row;
    },
    numberLength() {
      if (this.forms.number.length >= 6) {
        this.forms.number = this.forms.number.substring(0, 6);
      }
    },
    changeNumber() {
      if (this.form.num >= this.row.sum - this.row.use) {
        this.form.num = this.row.sum - this.row.use;
      }
    },
    //获取数据
    getMenuList() {
      getData("call.CallSeatController/listAction").then((res) => {
        if (res.code !== 200) return this.$message.error(res.message);
        this.tableData = res.data || [];
      });
    },
    //追加
    Add(row) {
      this.row = row;
      this.dialogaddVisible = true;
    },
    addAuthorization(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.$confirm("确定追加, 是否继续?", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
          })
            .then(() => {
              getData("call.CallSeatController/addAction", {
                num: this.forms.number,
              }).then((res) => {
                if (res.code !== 200) return this.$message.error(res.message);
                this.$message.success("新增成功");
                this.dialogaddVisible = false;
                this.$refs[formName].resetFields();
                this.number = "";
                this.getMenuList();
              });
            })
            .catch(() => {
              this.$message({
                type: "info",
                message: "已取消",
              });
              this.form.sums = 1;
            });
        } else {
          ("error submit!!");
          return false;
        }
      });
    },
    //派发
    Distribute(row) {
      this.row = row;
      this.select = 2;
      this.keywords = "";
      this.esarchang(1);
      this.call_type_id = row.call_type_id;
      this.form.call_type_id = row.call_type_id;
      this.dialogDistributeVisible = true;
    },
    onDistribute(formName) {
      if (!this.ids.length) return this.$message.error("请选择一个派发对象");
      if (this.ids.length > 1 && this.select == 2)
        return this.$message.error("一次只能派发一个代理商");
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.$confirm("确定派发, 是否继续?", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
          })
            .then(() => {
              delete this.form.userIdStr;
              delete this.form.user_id;
              if (this.select == 2) {
                this.form.user_id = this.ids.toString();
                this.url = "call.CallSeatController/setAgentAction";
              } else {
                this.form.userIdStr = this.ids.toString();
                this.url = "call.CallSeatController/setCommonAction";
              }
              getData(this.url, this.form).then((res) => {
                if (res.code == 200) {
                  this.$message({
                    message: "派发成功",
                    type: "success",
                  });
                  this.dialogDistributeVisible = false;
                  this.$refs[formName].resetFields();
                  this.getMenuList();
                } else {
                  this.$message.error(res.message);
                }
              });
            })
            .catch(() => {
              this.$message({
                type: "info",
                message: "已取消",
              });
              this.form.sums = 1;
            });
        } else {
          ("error submit!!");
          return false;
        }
      });
    },
    //详情
    Details(row) {
      this.$router.push({
        name: "AuthorizationDetail",
        params: { call_type_id: row.call_type_id },
      });
    },
    // 刷新
    shuaxin() {
      this.currentPage = 1;
      this.getMenuList();
      this.$message({
        type: "success",
        message: "刷新成功",
      });
    },
    headerCellStyle() {
      return "text-align:center;background-color:#F2f2f2;";
    },
    cellStyle() {
      return "text-align:center;";
    },
  },
  watch: {
    dialogDistributeVisible() {
      if (!this.dialogDistributeVisible) {
        this.$refs["form"].resetFields();
      }
    },
    dialogaddVisible() {
      if (!this.dialogaddVisible) {
        this.$refs["forms"].resetFields();
      }
    },
    select() {
      this.esarchang();
    },
  },
};
</script>
<style scoped lang="less">
.foot {
  width: 35%;
  height: 50px;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  border-top: 1px solid #e1e1e1;
  // margin-right: 20px;
  position: fixed;
  right: 0;
  bottom: 0;
  background-color: #fff;
  .el-button + .el-button {
    margin-right: 20px;
  }
}
.bing {
  width: 384px;
}
.warning {
  color: #f56c6c;
}
.el-tabs--border-card {
  border: 0;
  box-shadow: none;
}
.el-container {
  display: flex;
  flex-direction: column;
}

.zrss {
  display: flex;
  .moban {
    margin-left: 10px;
    padding: 0px 20px;
    font-size: 14px;
    height: 38px;
    margin-top: 1px;
    line-height: 36px;
  }
}
.qing {
  color: #46c160;
}
.jing {
  color: #ec5952;
}
.el-span {
  line-height: 40px;
}
</style>
<style lang="less" src="@/assets/css/Authorized.less" scoped></style>
<style src="@/assets/css/index.css" scoped></style>;
<style lang="less" scoped>
/deep/ .el-form-item__error {
  left: 167px !important;
}
</style>
